import EnrollmentDatasetPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentDatasetPropertyField';
import EnrollmentEventPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/EnrollmentEventPropertyField';
import FetchedObjectPropertyField from 'automation-ui-action-features/actions/extension/generic-extension/FetchedObjectPropertyField';
import FieldDataField from 'automation-ui-action-features/actions/extension/generic-extension/FieldDataField';
import PropertyField from 'automation-ui-action-features/actions/extension/generic-extension/PropertyField';
import { ACTION_OUTPUTS, ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
const convertFieldDataToDataToken = genericActionField => {
  const fieldValueRecord = genericActionField.getFieldValue();
  if (!fieldValueRecord) return '';
  if (fieldValueRecord instanceof FieldDataField) {
    const {
      actionId,
      dataKey
    } = fieldValueRecord.fieldDataIdentifier || {};
    const rawToken = `${ACTION_OUTPUTS}.action_output_${actionId}.${dataKey}`;
    return getTokenParts(rawToken).formattedToken;
  }
  if (fieldValueRecord instanceof EnrollmentDatasetPropertyField || fieldValueRecord instanceof EnrollmentEventPropertyField || fieldValueRecord instanceof FetchedObjectPropertyField) {
    return getTokenParts(fieldValueRecord.propertyToken).formattedToken;
  }
  if (fieldValueRecord instanceof PropertyField) {
    const {
      propertyName
    } = fieldValueRecord;
    const rawToken = propertyName ? `${ENROLLED_OBJECT}.${propertyName}` : '';
    return getTokenParts(rawToken).formattedToken;
  }
  const maybeString = fieldValueRecord.getValue();
  return typeof maybeString === 'string' ? maybeString : '';
};
export default convertFieldDataToDataToken;